function doValidate(prop, validation) {
  if (!prop.valid) {
    return prop;
  }

  prop.valid = validation(prop);

  if (!prop.valid) {
    prop.message = null;
  }

  return prop;
}

class Property {
  constructor(property) {
    this.property = property;
    this.valid = true;
    this.message = null;
  }

  validate() {
    return !this.valid && this.message;
  }

  required() {
    return doValidate(this, prop => (
      typeof (prop.property) === 'string'
        ? Boolean(prop.property.trim())
        : Boolean(prop.property)
    ));
  }

  equals(other) {
    return doValidate(this, prop => (
      prop.property === other
    ));
  }

  pattern(p) {
    return doValidate(this, prop => (
      p.test(prop.property)
    ));
  }

  withMessage(message) {
    if (this.valid) {
      return this;
    }

    if (!this.message) {
      this.message = message;
    }

    return this;
  }
}

function check(property) {
  return new Property(property);
}

export default check;
